<template>
    <div class="user-description">
        <div class="user-description__inner">
            <div class="user-description__row" v-if="description">
                <div class="user-description__title">Краткие сведения</div>
                <div class="user-description__text">{{ description }}</div>
            </div>
            <div class="user-description__row flex v-center between" v-if="social.length > 0">
                <div class="user-description__title">Социальные сети</div>
                <div class="user-description__social">
                    <a-btn :href="item.url" rel="nofollow" target="_blank" v-for="(item, i) in social" :key="i">
                        <template #content>
                            <img :src="item.icon">
                        </template>
                    </a-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { ABtn } from '../ui'

export default {
    name: 'UserDescription',
    components: {
        ABtn,
    },
    props: {
        description: {
            type: String,
            default: '',
        },
        social: {
            type: Array,
            default: () => [],
        }
    },
    setup: (props, ctx) => {
        return {}
    },
}
</script>

<style lang="scss" scoped>
    .user-description {
        &__inner {
            padding: 30px;
            border-radius: var(--br-1);
            border: 1px solid var(--c-gray-700);

            @include tablet {
                padding: 24px;
            }
        }
        &__row {
            margin-top: 27px;
            padding-top: 24px;
            border-top: 1px solid var(--c-gray-700);
            &:first-child {
                margin-top: 0;
                padding-top: 0;
                border-top: none;
            }
        }
        &__title {
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
        }
        &__text {
            margin-top: 14px;
            font-size: 14px;
            line-height: 20px;
        }
        &__social {
            ::v-deep(.a-btn) {
                color: #fff;
                width: 30px;
                height: 30px;
                padding: 0;
                background: #2F3941;
                margin-left: 8px;

                img {
                    filter: brightness(10);
                    width: 14px;
                }
            }
        }
    }
</style>